// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".animate-slideIn[data-v-7a081331]{animation:slideIn-7a081331 .2s ease}@keyframes slideIn-7a081331{0%{opacity:0;transform:translateX(-12px)}to{opacity:1;transform:translateX(0)}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
